"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPromotion = addPromotion;
exports.queryPromotionDetail = queryPromotionDetail;
exports.queryPromotionPage = queryPromotionPage;
exports.toggleEnable = toggleEnable;
exports.updatePromotion = updatePromotion;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityPromotion';

// 获取优惠活动分页列表
function queryPromotionPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取优惠活动详情
function queryPromotionDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 添加优惠活动
function addPromotion(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}
// 修改优惠活动
function updatePromotion(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 快捷切换活动启用状态
function toggleEnable(fnId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleEnable',
    method: 'put',
    params: {
      fnId: fnId,
      markForEnable: markForEnable
    }
  });
}